import type { InfiniteListPage } from "./infinite-list.type";
import type { ApiPayloadList } from "@/services/api";

import { isNormalPagination, isSimplifiedPagination } from "@/services/api";

import { getListPayloadData, getListPayloadPagination } from "../list";

export const getInfiniteListPageData = <Data = unknown>(
  payload: ApiPayloadList<Data>
): InfiniteListPage<Data> => ({
  data: getListPayloadData(payload),
  paginationParams: getListPayloadPagination(payload),
});

const getInfiniteQueryNextPage = (currentPage: number, hasNext: boolean) => {
  return currentPage && hasNext ? currentPage + 1 : undefined;
};

export const getInfiniteQueryNextPageParam = <Data = unknown>(
  lastPage: InfiniteListPage<Data>
) => {
  const pagination = lastPage?.paginationParams;
  const currentPage = pagination?.meta?.current_page;

  // Simplified pagination
  if (isSimplifiedPagination(pagination)) {
    const hasNext = pagination.links.next !== null ? true : false;
    return getInfiniteQueryNextPage(currentPage, hasNext);
  }

  // Normal pagination
  if (isNormalPagination(pagination)) {
    const lastPage = pagination.meta.last_page;
    const hasNext = currentPage < lastPage ? true : false;
    return getInfiniteQueryNextPage(currentPage, hasNext);
  }

  return undefined;
};
